import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import {useCanViewAnnotations} from './useCanViewAnnotations';

/**
 * Fences adaptive and independent practice apart from `student_annotations`, so the
 * session-only tool can land in steps without exposing a partial surface.
 */
export const SESSION_ONLY_ANNOTATIONS_FLAG = 'student_annotations_session_only';

/** Composes the view gate, not the edit gate: these surfaces have no assignment to submit. */
export function useIsSessionOnlyAnnotationModeAvailable(): boolean {
  const canViewAnnotations = useCanViewAnnotations();
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(SESSION_ONLY_ANNOTATIONS_FLAG);

  return canViewAnnotations && isFeatureEnabled && !isLoading;
}
